const approvalApi = {
  APPROVALDATAAPI: 'CSVPA-China/api/approval/selectPage', //审批列表
  APPROVALREJECT: 'CSVPA-China/api/approval/reject', //审批拒绝
  APPROVALALLADOPT: 'CSVPA-China/api/approval/approvalAll', //审批全部通过
  APPROVALADOPT: 'CSVPA-China/api/approval/approval', //审批通过
  SELECTPAGERECORD: 'CSVPA-China/api/approval/selectPageRecord', //审批记录列表
  QUERYRECORDS: 'CSVPA-China/api/approval/queryRecords',
  BATCHREAD: 'CSVPA-China/api/approval/batchRead',
  UPDATERECORD: 'CSVPA-China/api/approval/updateRecord',
  GETNOREADCOUNT: 'CSVPA-China/api/approval/getNoReadCount',
}

export default approvalApi
